import { render } from "./cpt-choose-place-option.vue?vue&type=template&id=4d6433f4"
import script from "./cpt-choose-place-option.vue?vue&type=script&lang=js"
export * from "./cpt-choose-place-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__